export interface ResetStandardsActionType {
  type: '@standard/RESET_STANDARDS';
}

export const resetStandards = (): ResetStandardsActionType => ({
  type: '@standard/RESET_STANDARDS',
});
